/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useEffect, useState } from 'react'
import {FlatList,
Text,
View,
Image,
SafeAreaView,
Keyboard,
TouchableWithoutFeedback,
Platform} from 'react-native';
import {
CatalogUpdate,
EmptySearch,
FullScreenImageLoader} from '../../components';
import { Firestore, Crashlytics } from '../../firebase/config';
import styles from './styles';
//import * as Linking from 'expo-linking';
import {
    //Badge,
SearchBar,
ButtonGroup } from 'react-native-elements';
import * as Haptics from 'expo-haptics';
import { LinearGradient } from 'expo-linear-gradient';

export default function ActivityFeed(props) {
    console.log(`Running Activity Feed!`)
    const [catalogUpdates, setCatalogUpdates] = useState([]);
    const [views, setViews] = useState(null);
    const [viewingUpdates, setViewingUpdates] = useState([]);
    const [searchUpdates, setSearchUpdates] = useState([]);
    const [search , setSearch] = useState("");
    const [loading, setLoading] = useState(false)
    //const { navigation } = props;
    const userID = props.extraData.user.id;
    const networkStatus = props.extraData.networkStatus;
    //const lastUpdateFetch = props.extraData.user.lastUpdateFetch.timestamp;
    const productLines = props.extraData.account.product_lines;
    const updatesRef = Firestore.collection('Updates');
    const usersRef = Firestore.collection('users');
    const userViewsRef = usersRef.doc(userID).collection('Viewed');
    const [selectedIndex, setSelectedIndex] = useState(0);
    let catalogID;

    if (props.route.catalogID) {
        catalogID = props.route.catalogID;
    }
console.log(`Catalog ID ${catalogID}`)
//Gets user views for all allowed product lines
const getAllUserViews = () => {
        console.log(`Getting All User Views...`)
                const subscriber = userViewsRef
                    .onSnapshot(
                            querySnapshot => {
                            const allViews = []
                            querySnapshot.forEach(doc => {
                                const viewData = {
                                favorite: doc.data().favorite,
                                id: doc.id
                                }
                                allViews.push(viewData)
                            })
                       setViews(allViews);
                            //setLoading(false);
                        },
                        error => {
                        console.error("Error getting user views: ", error);
                        Crashlytics.recordError(error);
                        }
                    )
                    return () => subscriber();
};

//Gets User views for single allowed product line
const getUserViewsSingleCatalog = (catalogID) => {
    console.log(`Getting Single Catalog Views...`)
                const subscriber = userViewsRef
                .where('catalog', '==', catalogID)//configure this
                    .onSnapshot(
                            querySnapshot => {
                            const allViews = []
                            querySnapshot.forEach(doc => {
                                const viewData = {
                                favorite: doc.data().favorite,
                                id: doc.id
                                }
                                allViews.push(viewData)
                            })
                       setViews(allViews);
                        },
                        error => {
                        console.error("Error getting user views: ", error);
                        Crashlytics.recordError(error);
                        }
                    )
                    return () => subscriber();
};



//Gets User Views
useEffect(() => {
    console.log(`Getting User Views...`)
let task;
catalogID? (task = getUserViewsSingleCatalog(catalogID)) : (task = getAllUserViews());
return () => task;
},[]);


//Should you limit this to last 30 or so and then add additional via queries through the search bar?
//Also, you could paginate and add more upon reaching the end of the flatlist scroll.


//Also, this fires off each time you view or favorite an update...
//You should optimize this to load once, subsribe to updates...then,
//Hoook into the updates / views and re-load new updates into state, while mutating current updates within cache.

//If we have 200 updates and a user navs to the AF, there will be 200 reads.
//If they interact with an update, it will occur 200 additional reads to return to the AF screen.
//10 update interactions = 2,000 reads...
//For example, 6,300 users x 1 update = 6,300 reads for the one update.
//6,300 x 200 = 126,000 reads for all users to view 1 update on the activity feed screen.
//all users interact and return to activity feed screen, reads increase 2x an additional 126,000 reads.
//Toal # reads = 252,000 for one update!
//This number increases by 6,300 x 2 for each update.
//Formula below:

//number of potential reads = update x users x collection size x 2 = reads  (+receipts)


//Gets catalog updates for all allowed product lines.
const getAllUpdates = () => {
    console.log(`Getting All Updates...1...2...3...`)
 const subscriber = updatesRef
          .where('productLine', 'in', productLines)
          .orderBy('timestamp', 'desc')
              .onSnapshot(
                  querySnapshot => {
                      const allUpdates = []
                      querySnapshot.forEach(doc => {
                     const viewed = views.find(o => o.id === doc.id);
                     let viewedStatus;
                     let favorite;
                     if (viewed) {
                         viewedStatus = true;
                      favorite = viewed.favorite;
                     }
                     else {
                      viewedStatus = false;
                      favorite = false;
                     }
                          const update = doc.data()
                          update.id = doc.id
                          update.viewed = viewedStatus
                          update.favorite = favorite
                          allUpdates.push(update)
                      });
                      setCatalogUpdates(allUpdates)
                      setLoading(false)
                  },
                  error => {
                  console.error("Error getting catalog updates: ", error);
                  Crashlytics.recordError(error);
                  }
              )
              return () => subscriber();
}

//Gets catalog updates for a single catalog (allowed product line).
const getCatalogUpdates = (catalogID) => {
    console.log(`Getting Single Catalog Updates...`)
 const subscriber = updatesRef
          .where('catalog', '==', catalogID)
          .orderBy('timestamp', 'desc')
              .onSnapshot(
                  querySnapshot => {
                      const allUpdates = []
                      querySnapshot.forEach(doc => {
                     const viewed = views.find(o => o.id === doc.id);
                     let viewedStatus;
                     let favorite;
                     if (viewed) {
                      viewedStatus = true;
                      viewedStatus = viewed.favorite;
                     }
                     else {
                      viewedStatus = false;
                      favorite = false;
                     }
                          const update = doc.data()
                          update.id = doc.id
                          update.viewed = viewedStatus
                          update.favorite = favorite
                          allUpdates.push(update)
                      });
                      setCatalogUpdates(allUpdates)
                      console.log(`Setting Catalog Updates...`)
                      setLoading(false)
                  },
                  error => {
                  console.error("Error getting catalog updates: ", error);
                  Crashlytics.recordError(error);
                  }
              )
              return () => subscriber();
}

//Gets Updates
useEffect(() => {
    console.log(`Getting Catalog updates...`)
   let task;
    views&&(catalogID?(task = getCatalogUpdates(catalogID)):(getAllUpdates()));
    return () => task;
},[views]);


  useEffect(() => {
    let filter;
      switch (selectedIndex) {
    case 1:
    if (!search) {
    filter = catalogUpdates.filter(elem => elem.viewed !== true);
    setViewingUpdates(filter);
    }
    else {
        filter = viewingUpdates.filter(elem => elem.viewed !== true);
        setViewingUpdates(filter);
    }
    break;
    case 0:
    if (!search) {
    setViewingUpdates(catalogUpdates);}
    else {
    setViewingUpdates(searchUpdates);
    }
    break;
    case 2:
    if (!search) {
    filter = catalogUpdates.filter(elem => elem.favorite === true);
    setViewingUpdates(filter);
    }
    else {
    filter = viewingUpdates.filter(elem => elem.favorite === true);
    setViewingUpdates(filter);
    }
    }
  },[selectedIndex, catalogUpdates])

  useEffect(() => {
         const searchFilter = searchArray(search);
         const finalArray = findUnique(searchFilter);
         if (search === "") {
         setViewingUpdates(catalogUpdates);
         }
         else {
         setViewingUpdates(finalArray);
         setSearchUpdates(finalArray);
         }
         },[search])

      function findUnique(array) {
         return Array.from(new Set(array));
      }

  function searchArray(keyword) {
        const searchStringArray = [];
        catalogUpdates.forEach((elem) => {
        const searchFields = {
        title: elem.title,
        description: elem.description,
        catalog: elem.catalog,
        date: elem.date
        }
        Object.entries(searchFields).forEach(([key, value]) => {
        if (String(value).toLowerCase().includes(keyword.toLowerCase())) {
        searchStringArray.push(elem)
        }
        }
        );
        })
        return searchStringArray;
        }


const emptyList = () => {
return (
<>
{search.length > 0 && searchUpdates.length === 0 ? (
<EmptySearch
 title={"No matching updates"}
 subtitle={"Try your search again. Search fields include all update content"}
 iconName={"search"}
 />
) : (
<>
{selectedIndex === 2? (
<EmptySearch
 title={"No Favorites Yet!"}
 subtitle={"Use the star icon on an update to add it to your favorite's list."}
 iconName={"star"}
 color={'red'}
 />
) : (
<EmptySearch
 title={"All Caught Up!"}
 subtitle={"No Unread Updates"}
 iconName={"verified"}
 />
)}
 </>
)}
</>
)
}

    const emptyListNoNetwork = () => {
    return (
    <View style={styles.emptyListNoNetwork}>
    <Image
    source={require('../../../assets/iconOffline.png')}
    />
    <Text style={styles.loaderText}>Check Internet Connection</Text>
    </View>
    )
    }


    const renderCatalogUpdates = ({item, index}) => {
    return (
    <CatalogUpdate
     id={item.id}
     catalog={item.catalog}
     date={item.date}
     title={item.title}
     description={item.description}
     viewed={item.viewed}
     favorite={item.favorite}
     />
    )
    }

   if (loading) {
     return (
     //<Loader />
     <FullScreenImageLoader />
     )
   }

    return (
    <>
    {Platform.OS === 'web'? (
            <View style={styles.container}>
            <LinearGradient
            colors={['black', '#590000']}
            locations={[.1,1]}
            style={{flex: 1}}
            >
            <SafeAreaView
            style={{flex: 1}}
            >
                {viewingUpdates && (
                    <View style={styles.listContainer}>
                    <SearchBar
                     containerStyle={{backgroundColor: "transparent"}}
                     inputStyle={{color:'white'}}
                     placeholder="Search Updates..."
                     onChangeText={(text) => setSearch(text)}
                     value={search}
                     round={true}
                     />
                   <ButtonGroup
                    onPress={(index) => {
                    setSelectedIndex(index);
                    }}
                    selectedIndex= {selectedIndex}
                    buttons={['All Updates', 'Unread', 'Favorites']}
                    containerStyle={{marginBottom: 20}}
                    selectedButtonStyle={{backgroundColor: 'gray'}}
                    />
                     <FlatList
                     data={viewingUpdates}
                     renderItem={renderCatalogUpdates}
                     ListEmptyComponent={networkStatus.isConnected? emptyList : emptyListNoNetwork}
                     keyExtractor={(item) => item.id}
                     removeClippedSubviews={true}
                     showsVerticalScrollIndicator={false}
                     />
                    </View>
                )}
                </SafeAreaView>
                </LinearGradient>
            </View>
    ) : (
            <TouchableWithoutFeedback
            onPress={() => Keyboard.dismiss()}>
            <View style={styles.container}>
            <LinearGradient
            colors={['black', '#590000']}
            locations={[.1,1]}
            style={{flex: 1}}
            >
            <SafeAreaView
            style={{flex: 1}}
            >
            {viewingUpdates && (
                    <View style={styles.listContainer}>
                    <SearchBar
                    containerStyle={{backgroundColor: "transparent"}}
                    inputStyle={{color:'white'}}
                    placeholder="Search Updates..."
                    onChangeText={(text) => setSearch(text)}
                    value={search}
                    round={true}
                />
             <ButtonGroup
              onPress={(index) => {
              setSelectedIndex(index);
              Haptics.selectionAsync();
              }}
              selectedIndex= {selectedIndex}
              buttons={['All Updates', 'Unread', 'Favorites']}
              selectedButtonStyle={{backgroundColor: 'gray'}}
              containerStyle={{marginBottom: 20}}
               />
                     <FlatList
                     data={viewingUpdates}
                     renderItem={renderCatalogUpdates}
                     ListEmptyComponent={networkStatus.isConnected? emptyList : emptyListNoNetwork}
                     keyExtractor={(item) => item.id}
                     removeClippedSubviews={true}
                     showsVerticalScrollIndicator={false}
                     />
                    </View>
                )}
                </SafeAreaView>
                </LinearGradient>
            </View>
            </TouchableWithoutFeedback>
    )}
</>
)
}